import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';

export class Kit {
  componentBrand: UntypedFormControl;
  partType: UntypedFormControl;
  componentPartNumber: UntypedFormControl;
  description: UntypedFormControl;
  descriptionType: UntypedFormControl;
  descriptionLanguage: UntypedFormControl;
  quantityInKit: UntypedFormControl;
  quantityInKitUom: UntypedFormControl;
  soldSeparately: UntypedFormControl;
  thumbnail: UntypedFormControl;
}
